import CommonLayout from "../CommonLayout";

import Footer from "../../../components/Footer";
import Buttons, { InvoiceModal } from "./components/Buttons";
import Filters from "./components/Filters";
import InvoicesEmptyState from "./components/InvoicesEmptyState";
import Table from "./components/Table";

import { INVOICE_TABLE_COLUMNS } from "../../../config/tables";
import { useFetchInvoices } from "./hooks/useFetchInvoices";
import { FiltersType } from "./types/filters.type";
import { usePermissions } from "@/hooks/usePermissions";
import { useOnboardingStatus } from "@/hooks/useOnboardingStatus";
import { useTableFiltersCursor } from "../../../hooks/useTableFiltersCursor";
import { useTRPC } from "../../../trpc/client";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

const TABLE_KEY = "invoices";

const InvoicesContainer = () => {
  const { isEditor } = usePermissions();
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const [modal, setModal] = useState<InvoiceModal | null>(null);
  const { data: status } = useOnboardingStatus();
  const { queryFilters, setQueryFilters, cursor, setCursor } =
    useTableFiltersCursor<FiltersType>(TABLE_KEY);
  const { invoices, nextCursor, isLoading, refetch } = useFetchInvoices(
    queryFilters,
    cursor
  );

  const refetchAll = () => {
    refetch!();
    queryClient.invalidateQueries({
      queryKey: trpc.merchants.onboardingStatus.queryKey(),
    });
  };
  const showEmptyState = isEditor && !isLoading && status?.invoiceCount === 0;

  const filters = (
    <Filters queryFilters={queryFilters} setQueryFilters={setQueryFilters} />
  );
  const buttons = isEditor ? (
    <Buttons refetch={refetchAll} modal={modal} setModal={setModal} />
  ) : (
    <></>
  );
  const table = (
    <Table invoices={invoices} isLoading={isLoading} refetch={refetchAll} />
  );
  const footer = (
    <Footer
      tableProps={{
        fileName: "recaudos",
        items: invoices,
        columns: INVOICE_TABLE_COLUMNS,
        pagination: { tableKey: TABLE_KEY, nextCursor, setCursor, cursor },
      }}
    />
  );

  return CommonLayout({
    title: "Recaudos",
    subtitle: "Consulta y gestiona todos tus recaudos",
    filters,
    buttons,
    table,
    footer,
    children: showEmptyState ? <InvoicesEmptyState onOpen={setModal} /> : null,
  });
};

export default InvoicesContainer;
